<template>
  <list-table
    url="accdoc"
    title="لیست سند های حسابداری"
    detailUrl="editDocument"
    newUrl="newDocument"
    :fields="fields"
    :params="params"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../../components/table";
export default {
  name: "Documents",
  components:{
      "list-table": TableShowData,
  },
  data() {
    return {
      fields: [
        {
          key: "number",
          label: "شماره سند",
        },
        {
          key: "date",
          label: "تاریخ",
        },
        {
          key: "des",
          label: "توضیحات",
        },
        {
          key: "sumbed",
          label: "بدهکار",
        },
        {
          key: "sumbes",
          label: "بستانکار",
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
      params: [
        {
          label: "کد سند",
          field: "id_s",
          type: "text",
        },
        {
          label: "شماره سند",
          field: "number",
          type: "text",
        },
        {
          label: "توضیحات",
          field: "des",
          type: "text",
        },
        {
          label: "تاریخ از",
          field: "date_from",
          type: "date-picker",
        },
        {
          label: "تاریخ تا",
          field: "date_to",
          type: "date-picker",
        }],
    };
  },
   mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "لیست سندهای حسابداری" }]);
  },
};

</script>